/**
 * @generated SignedSource<<5dbc82b64489d78f371addebc448db69>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
import { FragmentRefs } from "relay-runtime";
export type appointmentDrawerStatusIndicator_appointment$data = {
  readonly completedAt: string | null;
  readonly id: string;
  readonly isCompleted: boolean;
  readonly patient: {
    readonly patientFileLock: {
      readonly lockedAt: string | null;
      readonly lockedBy: string | null;
    };
  };
  readonly status: AppointmentStatus;
  readonly takenBy: string | null;
  readonly " $fragmentType": "appointmentDrawerStatusIndicator_appointment";
};
export type appointmentDrawerStatusIndicator_appointment$key = {
  readonly " $data"?: appointmentDrawerStatusIndicator_appointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentDrawerStatusIndicator_appointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentDrawerStatusIndicator_appointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "takenBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PatientFileLock",
          "kind": "LinkedField",
          "name": "patientFileLock",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockedBy",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};

(node as any).hash = "b9a03c4db0c669b4007a77fd849746cf";

export default node;
